"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Container = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
const Box = styled_components_1.default.div `
  display: flex;
  border-radius: 12px;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 80%;
  overflow: hidden;

  @media (max-width: 768px) {
    width: 90%;
    max-width: 400px;
  }

  @media (max-height: 712px) {
    padding: 10px;
    max-height: 50%;
  }
`;
const TextBox = styled_components_1.default.div `
  flex-grow: 1;
  margin-right: 20px;
  text-align: ${({ isRevert }) => (isRevert ? 'right' : 'left')};
  font-size: clamp(16px, 3vw, 80px);
  font-weight: 700;
  font-family: Phenomena;
  color: #6E76FB;
`;
const Answer = styled_components_1.default.span `
  color: ${({ isCorrect }) => (isCorrect ? '#3CB949' : '#FE2B45')};
  font-weight: bold;
  text-decoration: underline;
`;
const ImageBox = styled_components_1.default.div `
  flex-shrink: 0;
  display: flex;
  justify-content: end;
  align-items: end;
`;
const Image = styled_components_1.default.img `
  max-width: 100%;
  max-height: 100%;
`;
const AnswerCardBox = ({ list, isRevert }) => {
    return (react_1.default.createElement(Container, null, list.map((item, index) => {
        var _a;
        const parts = (_a = item === null || item === void 0 ? void 0 : item.question) === null || _a === void 0 ? void 0 : _a.split('*');
        return (react_1.default.createElement(Box, { key: index },
            react_1.default.createElement(TextBox, { isRevert: isRevert }, parts === null || parts === void 0 ? void 0 :
                parts[0],
                typeof (item === null || item === void 0 ? void 0 : item.isCorrect) === 'boolean' ? (react_1.default.createElement(Answer, { isCorrect: item === null || item === void 0 ? void 0 : item.isCorrect }, item === null || item === void 0 ? void 0 : item.answer)) : ('________'), parts === null || parts === void 0 ? void 0 :
                parts[1]),
            react_1.default.createElement(ImageBox, null,
                react_1.default.createElement(Image, { src: (item === null || item === void 0 ? void 0 : item.hint) || `https://via.placeholder.com/100?text=Image+${index + 1}`, alt: `Image ${index + 1}` }))));
    })));
};
exports.default = AnswerCardBox;
